var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 111,
    height: 113
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#BFBFBF",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.613,
    cy: 38.725,
    strokeWidth: 7,
    rx: 38.613,
    ry: 38.725
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M66.676 68.344L92.523 94.26"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M78.333 80.074L102 104"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.63 27.852)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.699,
    cy: 5.587,
    fill: "#BFBFBF",
    fillRule: "nonzero",
    rx: 5.699,
    ry: 5.587
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.894,
    cy: 5.587,
    fill: "#BFBFBF",
    fillRule: "nonzero",
    rx: 5.699,
    ry: 5.587
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BFBFBF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M6.439 30.028c1.485-3.868 4.938-5.802 10.357-5.802 5.42 0 8.872 1.934 10.358 5.802"
  })))));
}
export default SvgFilterSearch;